<template>
  <div class="match-type">
    <div v-if="statusGroup.includes('live')" class="match-type__live">
      <app-status>LIVE</app-status> матч
    </div>
    <div v-else class="match-type__ongoing">
      {{ (description && description.type) || null }}
    </div>
  </div>
</template>

<script>
import AppStatus from "@/components/ui/status/AppStatus";

export default {
  name: "MatchType",
  components: {
    AppStatus
  },
  props: {
    description: {},
    statusGroup: {}
  }
};
</script>

<style lang="scss">
.match-type {
  font-weight: bold;
  font-size: 24px;
  line-height: 33px;
  margin: 8px 0;

  &__live {
    span {
      color: #e72f31;
    }

    .status {
      vertical-align: bottom;

      span {
        margin-left: 8px;
      }
    }
  }
}
</style>
